import '../../../common/dashboard/filters/applied/applied_filter_view.js.coffee'
Namespace 'CustomerVisualMode.Filters.Applied'

class CustomerVisualMode.Filters.Applied.AppliedDateFilterView extends Common.Dashboard.Filters.AppliedFilterView

  _displayTitle: ->
    I18n.t 'customer_visual_mode.filters.date.title'

  _displayValues: ->
    type = @filter.getValues()['type']
    switch type
      when 'current_day' then [{name: I18n.t 'customer_visual_mode.filters.date.current_day'}]
      when 'all_history' then [{name: I18n.t 'customer_visual_mode.filters.date.all_history'}]
      when 'last_interval' then [{name: @_timeIntervalInSeconds()}]
      when 'date_range' then [
        {name: "#{I18n.t 'customer_visual_mode.filters.date.range_from'}: #{@_rangeStart()}"}
        {name: "#{I18n.t 'customer_visual_mode.filters.date.range_to'}: #{@_rangeEnd()}"}
      ]
      when 'date_range_until_now' then [
        {name: "#{I18n.t 'customer_visual_mode.filters.date.range_from'}: #{@_rangeStart()}"}
        {name: "#{I18n.t 'customer_visual_mode.filters.date.range_to'}: #{@_untilNow()}"}
      ]
      else throw new Error "Unknown date filter type #{type}"

  _rangeStart: ->
    @_formattedDate @filter.getValues()['start_time']

  _rangeEnd: ->
    @_formattedDate @filter.getValues()['end_time']

  _timeIntervalInSeconds: ->
    timeIntervalInSeconds = @filter.getValues()['time_interval_in_seconds']
    converter = new CustomerVisualMode.Filters.LastInterval.Converters.Converter()
    converter.getLabelFromSeconds(timeIntervalInSeconds)

  _formattedDate: (string) ->
    Date.create(string).format 'DD-MM-YYYY HH:mm'

  _untilNow: ->
    I18n.t('monitoring.dashboard.filters.filter_names.time.now')
